import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import LoadingOverlay from 'react-loading-overlay';
import {
  Modal, ModalBody, Button, Input,
} from 'reactstrap';
import { useLazyQuery } from 'react-apollo';
import ReactTagInput from '@pathofdev/react-tag-input';
import { map, omit } from 'lodash';
import '@pathofdev/react-tag-input/build/index.css';
import {
  validationMessages, regexPattern, loaderStyle, FALLBACK_ICON, capitalizeEveryWord, NUMERIC_VALUE,
} from '../../utils';
import { GET_RECOMENDED_ARTIST_QUERY } from '../../graphql-client/queries';
import { ArtistDetail } from '.';

function InviteArtistModal(props) {
  const {
    isOpen, onClose, categoriesData, basePrice, publishAndInviteOffer, isInviteOnly,
    offerId, targetAudience: { gender, country, audienceAge }, isPrivateType,
  } = props;

  const [modal, setModal] = useState(isOpen);
  const [tags, setTags] = useState([]);
  const [isEmailError, setEmailError] = useState(false);
  const [isInviteListError, setIsInviteListError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [defaultResults, setDefaultResults] = useState([]);
  const [artistDetailModal, setArtistDetailModal] = useState(false);
  const [artistDetailModalObj, setArtistDetailModalObj] = useState(null);
  const [isEmailSendToArtist, setIsEmailSendToArtist] = useState(isPrivateType);

  const updateArr = map(categoriesData, (ele) => omit(ele, ['_id', 'name', 'subCategoryId', '__typename']));
  const updatedCountry = map(country, (ele) => omit(ele, ['__typename']));
  (gender && gender.__typename) && delete gender.__typename;
  (audienceAge && audienceAge.__typename) && delete audienceAge.__typename;
  const [getCategoriesData, {
    loading, data: artistListData,
  }] = useLazyQuery(
    GET_RECOMENDED_ARTIST_QUERY, {
    variables: {
      offerId,
      categories: updateArr,
      audienceAge,
      country: updatedCountry,
      gender,
    },
    fetchPolicy: 'network-only', // Note: need this because we are using functionality
  },
  );

  const artistList = artistListData && artistListData.recomendedUser && artistListData.recomendedUser.data;
  const [artistState, setArtistState] = useState([]);

  useEffect(() => {
    if (updateArr && basePrice >= NUMERIC_VALUE.ZERO) {
      getCategoriesData();
    }
  }, [updateArr && basePrice]);

  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const addEmailTag = (newTags) => {
    setTags(newTags.map((val) => val.toLowerCase()));
    setIsInviteListError(false);
    setEmailError(false);
  };

  useEffect(() => {
    if (basePrice >= NUMERIC_VALUE.ZERO && artistList) {
      const updatedList = map(artistList, (val) => {
        val.basePrice = (val && val.basePrice) || basePrice;
        val.email = val.email ? val.email : val.managerId.email;
        val.isRequested = val.isAlreadyRequested ? true : false;
        return val;
      });
      setArtistState(updatedList);
      setDefaultResults(updatedList);
    }
  },
    [artistList && basePrice, modal]);

  useEffect(() => {
    let filteredData = defaultResults.filter(team => (
      (((team.email ? team.email : " ").toLowerCase()).includes(searchTerm.toLowerCase())) ||
      (((team.name ? team.name : " ").toLowerCase()).includes(searchTerm.toLowerCase()))
    ));
    setArtistState(filteredData)
  }, [searchTerm]);

  const handleBasePriceChange = (e) => {
    const updatedList = [...artistState];
    if (regexPattern.NUMBER_ONLY_WITH_DECIMAL.test(e.target.value)) {
      updatedList[e.target.dataset.idx].basePrice = e.target.value;
      setArtistState(updatedList);
    }
  };

  const handleChangeCheckbox = (e) => {
    const updatedList = [...artistState];
    updatedList[e.target.dataset.idx].isRequested = e.target.checked;
    setIsInviteListError(false);
    setArtistState(updatedList);
  };
  const renderArtistList = () => {
    return (
      <>
        {artistState && artistState[0] ? artistState.map((item, idx) => {
          const basePriceId = `basePrice-${idx}`;
          const checkboxId = `checkbox-${idx}`;
          const artistImage = item.artistImage ? item.artistImage : FALLBACK_ICON;
          return (<>
            <div className={`modal-publish-list-row ${item.isAlreadyRequested ? 'disabled-row' : ''}`} key={`${item.artistImage}`}>
              <div
                className="modal-publish-list-row-image cursor-pointer"
                onClick={() => {
                  setArtistDetailModal(true);
                  setArtistDetailModalObj({ _id: item._id });
                }}
              >
                <img
                  src={artistImage}
                  alt="user"
                  className="image-cover"
                />
              </div>
              <div
                className="modal-publish-list-row-name"
                onClick={() => {
                  setArtistDetailModal(true);
                  setArtistDetailModalObj({ _id: item._id });
                }}
              >
                <h3>
                  {capitalizeEveryWord(item.name)}
                  {item.isRecomended
                    && (
                      <em>Recommended</em>
                    )}
                </h3>
                <p>{item.email}</p>
              </div>
              <div className="modal-publish-list-row-input">
                <Input
                  data-idx={idx}
                  id={basePriceId}
                  name={basePriceId}
                  type="text"
                  value={artistState[idx].basePrice}
                  onChange={handleBasePriceChange}
                  disabled={!artistState[idx].isRequested}
                />
                <em>$</em>
              </div>
              <div className="modal-publish-list-row-checkbox">
                <label htmlFor={checkboxId} className="input-container-green">
                  <input
                    data-idx={idx}
                    onChange={handleChangeCheckbox}
                    name={checkboxId}
                    id={checkboxId}
                    type="checkbox"
                    checked={artistState[idx].isRequested || false}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            </div>
          </>)
        }) :
          <div className="no-offer-content">
            <div className="no-table-data">
              <h2>No results found</h2>
              <p>Try using a different name or keyword</p>
            </div>
          </div>
        }
      </>)
  };

  const handleInviteArtist = () => {
    const inviteArtistList = [];
    map(artistState, (artist) => {
      if (artist.isRequested && !artist.isAlreadyRequested) {
        const updatedArr = {
          artistId: artist._id,
          name: artist.name,
          basePrice: Number(artist.basePrice),
          email: artist.email ? artist.email : artist.managerId && (artist.managerId.email),
        };
        inviteArtistList.push(updatedArr);
      }
    });
    const inviteObj = {
      inviteArtistList,
      additionalEmail: tags,
      isEmailSendToArtist,
    };
    if (inviteArtistList.length || tags.length) {
      publishAndInviteOffer(inviteObj);
      toggle();
      onClose();
    } else {
      setIsInviteListError(true);
    }
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggle} className="modal-publish modal-dialog-centered">
        <ModalBody>
          <div className="modal-publish-header">
            <div className="modal-publish-header-text">
              <h2>
                {
                  isPrivateType ? 'Add Artist to Gig' : 'Select Artist for this opportunity'
                }
              </h2>
              <p>Brand partnership opportunity</p>
            </div>
            <Button
              type="button"
              color="publish"
              onClick={handleInviteArtist}
            >
              {
                isInviteOnly ? 'Invite' : 'Invite & publish'
              }
            </Button>
          </div>
          {
            isPrivateType
            && (
              <div className="checkbox-with-text">
                <label htmlFor="inviteArtist" className="input-container-green">
                  <input
                    name="inviteArtist"
                    id="inviteArtist"
                    type="checkbox"
                    checked={isEmailSendToArtist}
                    onClick={(e) => setIsEmailSendToArtist(e.target.checked)}
                  />
                  <span className="checkmark" />
                </label>
                <span className="checkbox-text">Send Invite email to Artists</span>
              </div>
            )
          }
          <div className="modal-publish-search">
            <div className="search">
              <Input
                type="search"
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value) }}
                placeholder="Search Artist"
              />
              <span className="search-icon" />
            </div>
            <span className="form-error-text">
              {' '}
              {isInviteListError && validationMessages.INVITE_ARTIST}
              {' '}
            </span>
          </div>
          <div className="modal-publish-list">
            <LoadingOverlay
              active={loading}
              spinner
              text=""
              className="inviteListLoader"
              styles={loaderStyle}
            >
              <Scrollbars
                style={{ width: '100%', height: 380 }}
                thumbMinSize={30}
              >
                {renderArtistList()}
              </Scrollbars>
            </LoadingOverlay>
          </div>
          <div className="modal-publish-invite-email">
            <h3>Looking for a new Artist for this opportunity?</h3>
            <h3>Invite via email address.</h3>
            <ReactTagInput
              tags={tags}
              placeholder="Enter email address"
              editable
              readOnly={false}
              removeOnBackspace
              onChange={(newTags) => addEmailTag(newTags)}
              validator={(value) => {
                const isEmail = regexPattern.EMAIL.test(value);
                const isTagError = tags.includes(value.toLowerCase());
                setEmailError(!isEmail || isTagError);
                return (isEmail && !isTagError) && isEmail;
              }}
            />
            <span className="form-error-text">
              {' '}
              {isEmailError && validationMessages.INVALID}
              {' '}
            </span>
          </div>
        </ModalBody>
      </Modal>
      {artistDetailModal && artistDetailModalObj && (
        <ArtistDetail
          isOpen={artistDetailModal}
          onClose={() => {
            setArtistDetailModal(!artistDetailModal);
          }}
          userId={artistDetailModalObj._id}
          canEdit={false}
          key={Math.random()}
        />
      )}
    </>
  );
}
InviteArtistModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  categoriesData: PropTypes.array.isRequired,
  basePrice: PropTypes.number.isRequired,
  publishAndInviteOffer: PropTypes.func.isRequired,
  isInviteOnly: PropTypes.bool.isRequired,
  offerId: PropTypes.string,
  targetAudience: PropTypes.object,
  isPrivateType: PropTypes.bool,
};

InviteArtistModal.defaultProps = {
  offerId: null,
  targetAudience: null,
  isPrivateType: true,
};

export default InviteArtistModal;
